import {pullRequestsAppBuilder} from '../config/app-builder'
import {reactFetchJSON} from '@github-ui/verified-fetch'
import type {CommitsRoutePayload} from './Commits'
import {reportTraceData} from '@github-ui/internal-api-insights'

export const {pullRequestsCommitsRoute} = pullRequestsAppBuilder.createQueryRouteConfig('pullRequestsCommitsRoute', {
  path: '/:owner/:repo/pull/:pr_number/commits',
  queries: [
    {
      queryName: 'payload',
      queryDeps: ({path}) => {
        return {path}
      },
      queryFn: async ({queryDeps: {path}}) => {
        const response = await reactFetchJSON(path)
        if (!response.ok) throw new Error(`${response.status} on ${response.url}`)
        const json = await response.json()
        reportTraceData(json)
        return json.payload as CommitsRoutePayload
      },
      staleTime: Infinity,
    },
  ],
})
